import {getAccessToken} from "./Auth";
import axios from "axios";
import Notification from "../components/Notification";
import {Tooltip} from "@mui/material";
import Constants from "./Constants";


export function formatDate(epoch) {
    const options = { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'};
    const seconds = Math.trunc(epoch) * 1000
    return new Date(seconds).toLocaleString('en-US', options)
}


export function formatText(msg, n_chars) {
    if (msg.charAt(0) === '"' && msg.charAt(msg.length -1) === '"') {
        msg = msg.substring(1, msg.length -1)
    }
    if (msg.length > n_chars) {
        let title = msg.substring(0, n_chars)
        return <Tooltip title={<h3>{msg}</h3>} arrow>{title}</Tooltip>
    }
    else {
        return <div>{msg}</div>
    }
}

export function condenseFilename(filename, n_chars) {
    // function to condense strings down to a maximum number of characters
    // provides tooltip for the full string when hovered over
    if (typeof filename === 'string') {
        if (filename.length < n_chars) {
            return filename
        } else {
            const prefix = filename.substring(0, 12)
            const postfix = filename.substring(filename.length - (n_chars - 14))
            return <Tooltip title={<div style={{whiteSpace: 'pre-line'}}>{filename}</div>}>
                <div>{prefix}..{postfix}</div>
            </Tooltip>
        }
    }
    else {
        return filename
    }
}


export function formatFileList(files) {
    // function to reduce a long list into 1-2 lines and add truncated lines to Tooltip you can hover over
    if (files !== undefined) {
        const n_files = files.length
        if (n_files === 0) {
            return <div></div>
        } else if (n_files === 1) {
            return <div>{condenseFilename(files[0], 45)}</div>
        } else if (n_files === 2) {
            return <div>{condenseFilename(files[0], 45)}<br/>{condenseFilename(files[1], 45)}</div>
        } else {
            const tip = files.join("\n")
            return <Tooltip title={<div style={{whiteSpace: 'pre-line'}}>{tip}</div>}>
                <div>{files[0]} + {n_files - 1} more</div>
            </Tooltip>
        }
    }
    else {
        return <div></div>
    }
}


export function makeAlphanumeric(characters) {
        var cleaned = characters.replace(/[^a-zA-Z0-9_-]+/g,"");
        return cleaned.toLowerCase()
    }


export function epochSeconds() {
    var d = new Date();
    return Math.round(d.getTime() / 1000);
}


export function getTimeDeltaHuman(time) {
    let now = Date.now() / 1000
    const deltaTimeSeconds = now - time
    if (deltaTimeSeconds < 30) {
        return 'just now'
    }
    else if (deltaTimeSeconds < 180) {
        return 'about a minute ago'
    }
    else if (deltaTimeSeconds < 3000) {
        const mins = Math.round(deltaTimeSeconds / 60)
        return mins + ' minutes ago'
    }
    else if (deltaTimeSeconds < 80000) {
        const hrs = Math.round(deltaTimeSeconds / 60 / 60)
        return hrs + ' hours ago'
    }
    else {
        const days = Math.round(deltaTimeSeconds / 60 / 60 / 24)
        return days + ' days ago'
    }
}


export function getRandom(mode, length) {
    let result = '';
    if (mode === 'alphanumeric') {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const n_chars = chars.length
        let counter = 0;
        while (counter < length) {
          result += chars.charAt(Math.floor(Math.random() * n_chars));
          counter += 1;
        }
    }
    if (mode === 'loweralpha') {
        const chars = 'abcdefghijklmnopqrstuvwxyz';
        const n_chars = chars.length
        let counter = 0;
        while (counter < length) {
          result += chars.charAt(Math.floor(Math.random() * n_chars));
          counter += 1;
        }
    }
    return result
}


export function isHidden(field, headers) {
        for (let i = 0; i < headers.length; i++) {
            if (headers[i]['field'] === field) {
                if (headers[i]['hidden'] === true) {
                    return true
                }
            }
        }
        return false
    }


export function getItemField(uuid, field, items) {
        // myArray.find(x => x.id === '45').foo;
        //console.log(JSON.stringify(items))
        console.log('uuid: ' + uuid)
        let item = items.find(x => x.pk === uuid)
        // console.log(JSON.stringify(item))
        if (item) {
            if (item[field]) {
                return item[field]
            }
            else {
                return ''
            }
        }
        else return ''
    }


export const getDetail = async (base_url, obj_type, uuid, setSelection, openDialog) => {
    let url = base_url + "/" + uuid
    const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
    console.log('get: ' + url + ' ' + JSON.stringify(headers))
    await axios
        .get(url, { headers: headers })
        .then(res => {
            const item = res.data[obj_type];
            console.log(JSON.stringify(res))
            console.log('detections: ' + JSON.stringify(item?.detections))
            for (let det in item?.detections) {
                let name = item?.detections[det].name
                console.log('det: ' + name + ' mode: ' + item?.detections[det].mode)
                item['detection_mode_' + name] = parseInt(item.detections[det].mode, 10)
            }
            setSelection(item)
            console.log(obj_type + ' getDetail: ' + JSON.stringify(item))
            openDialog(true)
        })
        .catch(err => {
            if (err.response) {
              console.log('bad response from server: ' + err.response)
            } else if (err.request) {
              console.log('no response from server: ' + err.request)
            } else {
              console.log(err)
            }
            Notification(`Error while fetching ${url}. ${err}`, 'error');
        })
}

export const getFileUrls = async (base_url, obj_type, template_type, uuid, setUrl1, setUrl2) => {
    console.log("obj_type = " + obj_type)
    let obj_type_pretty = obj_type
    if (obj_type === 'analyzer') {
        obj_type_pretty = 'Analyzer' + uuid
    }
    else if (obj_type === 'site') {
        obj_type_pretty = 'SitePolicies'
    }
    let cfn_base_url = 'https://console.aws.amazon.com/cloudformation/home?region=us-east-1#/stacks/create/review?stackName=' + Constants.applicationName + obj_type_pretty + '&templateURL='
    let url = base_url + "/" + uuid + '?template=' + template_type
    const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
    console.log('get: ' + url + ' ' + JSON.stringify(headers))
    await axios
        .get(url, { headers: headers })
        .then(res => {
            const file_url = res.data['msg']
            setUrl1(file_url)
            const cfn_url = cfn_base_url + encodeURIComponent(file_url)
            setUrl2(cfn_url)
        })
        .catch(err => {
            console.error('Error fetching file URL:', err);
        });
}

export const getStaticFileUrls = async (filename, setUrl1, params = '') => {
    let url = "https://" + Constants.apiHost + '.' + Constants.domainName + '/api/v1/files/'+ filename
    if (params !== '') {
        url = url + "?" + params
    }
    const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
    await axios
        .get(url, { headers: headers })
        .then(res => {
            console.log(JSON.stringify(res.data))
            const file_url = res.data['msg']
            setUrl1(file_url)
        })
        .catch(err => {
            console.error('Error fetching file URL:', err);
        });
}

export const getDirectFileUrl = async (filename, params = '') => {
    let url = "https://" + Constants.apiHost + '.' + Constants.domainName + '/api/v1/files/'+ filename
    if (params !== '') {
        url = url + "?" + params
    }
    const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
    await axios
        .get(url, { headers: headers })
        .then(res => {
            console.log(JSON.stringify(res.data))
            return res.data['msg']
        })
        .catch(err => {
            console.error('Error fetching file URL:', err);
        });
}

export const getPreferredSynologyFile = async (setUrl, release_type) => {
  const base = `https://${Constants.apiHost}.${Constants.domainName}/api/v1/versions`;
  const paramsCore = `platform=synology&release_type=${release_type.toLowerCase()}`;
  const attempts = [
    `${base}?${paramsCore}&preferred=true`,
    `${base}?${paramsCore}&latest=true`,
    `${base}?${paramsCore}`
  ];
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': await getAccessToken()
  };

  const sortVersions = (versions) => {
    return [...versions].sort((a, b) => {
      const num = v => ({
        preferred: v.preferred ? 1 : 0,
        latest: v.latest ? 1 : 0,
        major: parseInt(v.major || '0', 10),
        minor: parseInt(v.minor || '0', 10),
        build: parseInt(v.build || '0', 10)
      });
      const A = num(a), B = num(b);
      if (B.preferred !== A.preferred) return B.preferred - A.preferred;
      if (B.latest !== A.latest) return B.latest - A.latest;
      if (B.release_date !== A.release_date) return B.release_date - A.release_date;
      if (B.major !== A.major) return B.major - A.major;
      if (B.minor !== A.minor) return B.minor - A.minor;
      if (B.build !== A.build) return B.build - A.build;
      return 0;
    });
  };

  for (let i = 0; i < attempts.length; i++) {
    const url = attempts[i];
    try {
      console.log(`Synology versions attempt ${i + 1}: ${url}`);
      const res = await axios.get(url, { headers });
      const versions = res.data?.versions;
      if (Array.isArray(versions) && versions.length) {
        console.log(`Versions (att ${i + 1}): `, versions)
        const chosen = sortVersions(versions)[0];

        if (!chosen?.filename) {
          console.warn('Chosen version missing filename');
          continue;
        }
        // Capture the resolved URL via wrapper since getStaticFileUrls uses a setter callback
        let resolved = '';
        await getStaticFileUrls(
          chosen.filename,
          (u) => { resolved = u; setUrl(u); },
          'source=global'
        );
        if (resolved) {
          console.log('Resolved Synology installer URL:', resolved);
          return resolved;
        }
        console.warn('Empty URL returned for', chosen.filename);
      } else {
        console.log('No versions returned for attempt', i + 1);
      }
    } catch (e) {
      console.warn('Attempt failed', url, e?.response?.status);
    }
  }
  // All Synology version attempts failed; returning empty string
  setUrl('');
  return '';
};
